import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbModal, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../loader/loader.component';
import { MasterInformationService } from '../../Services/master-information.service';
import { apiEndPoints } from '../../api/apiEndPoint';
import { ToastrService } from 'ngx-toastr';
import { NoDataFoundComponent } from "../no-data-found/no-data-found.component";

@Component({
  selector: 'app-push-notification',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    FormsModule,
    LoaderComponent,
    NoDataFoundComponent
],
  templateUrl: './push-notification.component.html',
  styleUrl: './push-notification.component.css',
})
export class PushNotificationComponent implements OnInit {
  pushForm!: FormGroup;
  currentPage = 1;
  pageSize = 5;
  isEditMode: boolean = false;
  isPageLoading: boolean = false;
  notificationLists: any;
  pageSizes: number[] = [5, 10, 15, 20];
  selectedId: any;
  pushNotificationId: any;
  selectedTitle: any;
  filteredList: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private masterService: MasterInformationService,
    private toastr: ToastrService
  ) {
    this.pushForm = this.fb.group({
      Title: ['', [Validators.required]],
      Description: ['', [Validators.required]],
      ScreenNumber: ['', [Validators.required]],
      UserType: ['', [Validators.required]],
      Ar_Description: ['', [Validators.required]],
      Ar_Title: ['', [Validators.required]],
      dataContent: ['', [Validators.required]],
      Remarks: ['', [Validators.required]],
      notificationKey: ['', [Validators.required]],
    });
  }

  // --------------------------- OnInit --------------------------- //

  ngOnInit() {
    this.notificationList();
  }

  // --------------------------- Input Search --------------------------- //

  search(event: any) {
    const searchText = event.target.value.toLowerCase();

    this.filteredList = this.notificationLists.filter((data: any) => {
      return (
        data.title?.toLowerCase().includes(searchText) ||
        String(data.screenNumber)?.toLowerCase().includes(searchText) ||
        String(data.userType)?.toLowerCase().includes(searchText) ||
        data.notificationKey?.toLowerCase().includes(searchText)
      );
    });
  }
  // --------------------------- Pagination --------------------------- //

  onPageChange(page: number) {
    this.currentPage = page;
  }

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = this.currentPage * this.pageSize;
    return this.filteredList?.slice(start, end);
  }

  // --------------------------- Modal Open --------------------------- //

  openModal(content: any) {
    this.isEditMode = false;
    this.pushForm.reset();
    this.modalService.open(content, { size: 'lg' });
  }

  openEditModal(content: any, data: any) {
    console.log(data);
    this.selectedId = data.id;
    this.isEditMode = true;

    const userTypeMap: { [key: string]: string } = {
      '1': 'Individual Requester',
      '2': 'Corporate Requester',
      '3': 'Dumpster',
      '4': 'Dumpyard'
    };
    
    this.pushForm.patchValue({
      Title: data.title,
      Ar_Title: data.ar_Title,
      Description: data.description,
      Ar_Description: data.ar_Description,
      dataContent: data.dataContent,
      ScreenNumber: data.screenNumber,
      UserType: userTypeMap[data.userType.toString()],
      Remarks: data.remarks,
      notificationKey: data.notificationKey,
    });
    this.modalService.open(content, { size: 'lg' });
  }

  // --------------------------- Post API form push notification --------------------------- //

  createNotification() {
    this.isPageLoading = true;

    if (this.pushForm.valid) {
      const reqBody = {
        title: this.pushForm.value.Title,
        ar_Title: this.pushForm.value.Ar_Title,
        description: this.pushForm.value.Description,
        ar_Description: this.pushForm.value.Ar_Description,
        dataContent: this.pushForm.value.dataContent,
        screenNumber: Number(this.pushForm.value.ScreenNumber),
        userType: Number(this.pushForm.value.UserType),
        remarks: this.pushForm.value.Remarks,
        notificationKey: this.pushForm.value.notificationKey,
      };

      this.masterService
        .postPushNotification(apiEndPoints.createPushNotification, reqBody)
        .subscribe({
          next: (response: any) => {
            this.isPageLoading = false;
            if (response.isSuccess) {
              this.toastr.success(
                'Notification added successfully',
                'Success',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.modalService.dismissAll();
              this.pushForm.reset();
            } else {
              this.toastr.warning(
                'Something went wrong. Please check the form.',
                'Warning',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.pushForm.markAllAsTouched();
            }
          },
          error: () => {
            this.isPageLoading = false;
            this.toastr.error(
              'API error occurred. Please try again later.',
              'Error',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
          },
        });
    } else {
      this.isPageLoading = false;
      this.pushForm.markAllAsTouched();
      this.toastr.info('Please fill in all the required fields.', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
    }
  }

  // --------------------------- Update API form push notification --------------------------- //

  update() {
    this.isPageLoading = true;

    if (this.pushForm.valid) {
      const reqBody = {
        id: this.selectedId,
        title: this.pushForm.value.Title,
        ar_Title: this.pushForm.value.Ar_Title,
        description: this.pushForm.value.Description,
        ar_Description: this.pushForm.value.Ar_Description,
        dataContent: this.pushForm.value.dataContent,
        screenNumber: Number(this.pushForm.value.ScreenNumber),
        userType: Number(this.pushForm.value.UserType),
        remarks: this.pushForm.value.Remarks,
        notificationKey: this.pushForm.value.notificationKey,
      };

      this.masterService
        .postPushNotification(apiEndPoints.updatePushNotification, reqBody)
        .subscribe({
          next: (response: any) => {
            this.isPageLoading = false;
            if (response.isSuccess) {
              this.toastr.success(
                'Notification updated successfully',
                'Success',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.modalService.dismissAll();
              this.pushForm.reset();
              this.notificationList();
            } else {
              this.toastr.warning(
                'Something went wrong. Please check the form.',
                'Warning',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.pushForm.markAllAsTouched();
            }
          },
          error: () => {
            this.isPageLoading = false;
            this.toastr.error(
              'API error occurred. Please try again later.',
              'Error',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
          },
        });
    } else {
      this.isPageLoading = false;
      this.pushForm.markAllAsTouched();
      this.toastr.info('Please fill in all the required fields.', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
    }
  }

  // --------------------------- Get push notification list --------------------------- //

  notificationList() {
    this.isPageLoading = true;
    this.masterService
      .getPushNotification(apiEndPoints.notificationList)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.isPageLoading = false;
            this.notificationLists = response.body.details;

            this.filteredList = this.notificationLists;
          }
        },
        error: () => {
          this.isPageLoading = false;
          this.toastr.error(
            'API error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  onlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Stops input
    }
  }

  // --------------------------- Delete notification list --------------------------- //

  openDeleteModal(content: any, data: any) {
    this.pushNotificationId = data.id;
    this.selectedTitle = data.title;
    this.modalService.open(content, { size: 'md' });
  }

  deleteNotification() {
    this.isPageLoading = true;
    this.masterService
      .deleteNotification(
        apiEndPoints.deleteNotification,
        this.pushNotificationId
      )
      .subscribe({
        next: (response: any) => {
          this.isPageLoading = false;
          if (response.isSuccess) {
            this.toastr.success(
              'Notification deleted successfully',
              'Success',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
            this.modalService.dismissAll();
            this.notificationList();
          } else {
            this.isPageLoading = false;
            this.toastr.warning(
              'Something went wrong. Please check the form.',
              'Warning',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
          }
        },
        error: () => {
          this.isPageLoading = false;
          this.toastr.error(
            'API error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }
}
